import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, useClickOutside } from 'qampo-ui-library';
import { InputField } from '../../UI';
import { TEMPLATE_COLOR_PALETTE, type TemplateColorPalette } from '../../../constants/templateColors';
import styles from '../../../pages/TreatmentPlanBuilderPage.module.css';

interface TemplateColorPickerProps {
  strokeColor: string;
  onSelect: (colors: TemplateColorPalette) => void;
}

export const TemplateColorPicker = ({ strokeColor, onSelect }: TemplateColorPickerProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  useClickOutside(containerRef, () => setIsOpen(false));

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSelect = (colors: TemplateColorPalette) => {
    onSelect(colors);
    setIsOpen(false);
  };

  return (
    <div ref={containerRef} className={styles.swatchDropdown}>
      <InputField
        label={t('config-iv-color')}
        onClick={handleToggle}
        active={isOpen}
        className={styles.colorField}
      >
        <span className={styles.triggerColorDot} style={{ backgroundColor: strokeColor }} />
        <ChevronDown
          width={16}
          height={16}
          style={{
            marginLeft: 'auto',
            transition: 'transform 0.15s ease',
            transform: isOpen ? 'rotate(180deg)' : 'none'
          }}
        />
      </InputField>
      {isOpen && (
        <div className={styles.swatchPanel}>
          <div className={styles.colorPicker}>
            {TEMPLATE_COLOR_PALETTE.map((colors) => (
              <button
                key={colors.strokeColor}
                type="button"
                className={`${styles.colorSwatch} ${strokeColor === colors.strokeColor ? styles.colorSwatchActive : ''}`}
                style={{ backgroundColor: colors.strokeColor }}
                onClick={() => handleSelect(colors)}
                aria-label={colors.strokeColor}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
